import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SuspenseLoader from './components/Loader/SuspenseLoader';

import './App.scss';
import AuthGuard from './authGuard';
import PaymentSuccessful from './screens/PaymentSuccessful';
import VerifyEmailScreen from './screens/authScreens/VerifyEmailScreen';
import ForgotPasswordScreen from './screens/authScreens/ForgotPasswordScreen';
import ForgotPasswordResetScreen from './screens/authScreens/ForgotPasswordResetScreen';
import PaymentType from './screens/PaymentType';
import PublicPayment from './screens/PublicPayment';

const PasswordLogin = React.lazy(() => import('./screens/Login/PasswordLogin'));
const OtpLogin = React.lazy(() => import('./screens/Login/OtpLogin'));
const CreateAccount = React.lazy(() => import('./screens/CreateAccount'));
const Dashboard = React.lazy(() => import('./screens/Dashboard'));
const Onboarding = React.lazy(() => import('./screens/Onboarding'));
const NotFound = React.lazy(() => import('./components/NotFound'));

function App() {
  return (
    <div className="App">
      <AuthGuard>
        <React.Suspense fallback={<SuspenseLoader />}>
          <Routes>
            <Route path="/" element={<PasswordLogin />} />
            <Route path="/otp-login" element={<OtpLogin />} />
            <Route path="/get-started" element={<CreateAccount />} />
            <Route path="/get-verified" element={<VerifyEmailScreen />} />
            <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
            <Route path="/password-reset" element={<ForgotPasswordResetScreen />} />
            <Route path="/dashboard/*" element={<Dashboard />} />
            <Route path="/payment-success" element={<PaymentSuccessful />} />
            <Route path="/payment-type/:id/*" element={<PaymentType />} />
            <Route path="/pay/rent/:transactionReference" element={<PublicPayment />} />
            <Route path="/onboarding/*" element={<Onboarding />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </React.Suspense>
      </AuthGuard>
    </div>
  );
}

export default App;
